import React from "react";
import {
  makeStyles,
  Typography,
  ButtonBase,
  Box
} from "@material-ui/core";
import clsx from "clsx";
import PropTypes from "prop-types";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: "5px 12px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    backgroundColor: "#eceff0",
    borderRadius: 4,
    width: "100%",
    overflow: "hidden"
  },
  inputText: {
    fontSize: "0.875rem",
    color: "#a4a6a8",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontWeight: "500"
  },
  filled: {
    color: "rgba(0, 0, 0, 0.87)",
  },
  clearButton: {
    minWidth: 0
  }
}));

function ProductLanguageSelectComponent({
  handleClick,
  value,
  disabled,
  style,
  anchorRef,
  isEmpty,
  open,
  textStyle,
}) {
  const classes = useStyles();

  // Get display name for the language
  const getDisplayLanguage = () => {
    if (!value) return '';

    // Map of language codes to display names
    const languageDisplayNames = {
      "EN": "English",
      "ZH": "简体中文",
      "ZH-CN": "简体中文",
      "ZH-TW": "繁體中文",
      "ZHTW": "繁體中文",
      "VI": "Tiếng Việt",
      "TH": "ไทย",
      "MS": "Bahasa Melayu",
      "MS-MY": "Bahasa Melayu",
      "ID": "Bahasa Indonesia",
      "TL": "Tagalog (Filipino)"
    };

    // Try to find the language display name, case-insensitive
    const upperValue = value.toUpperCase();

    for (const [code, name] of Object.entries(languageDisplayNames)) {
      if (code.toUpperCase() === upperValue) {
        return name;
      }
    }

    return value;
  };

  return (
    <ButtonBase
      className={classes.root}
      disableRipple
      ref={anchorRef}
      onClick={handleClick}
      disabled={disabled}
      style={{ padding: 12, ...style }}
    >
      <Typography
        variant='body2'
        className={clsx(classes.inputText, {
          [classes.filled]: !isEmpty
        })}
        style={textStyle}
      >
        {getDisplayLanguage()}
      </Typography>
      <Box
        style={{
          display: "flex",
          alignItems: "center"
        }}
      >
        {!disabled && (open ? (
          <ArrowDropUpIcon fontSize='small' />
        ) : (
          <ArrowDropDownIcon fontSize='small' />
        ))}
      </Box>
    </ButtonBase>
  );
}

ProductLanguageSelectComponent.propTypes = {
  handleClick: PropTypes.func,
  value: PropTypes.any,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  isEmpty: PropTypes.bool
};

export default ProductLanguageSelectComponent;
